"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[674],{

/***/ 90674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ HorizontalSlideshow_HorizontalSlideshow; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./theme/mixins/padding.ts
var padding = __webpack_require__(54986);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 110 modules
var motion = __webpack_require__(86909);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/use-scroll.mjs + 23 modules
var use_scroll = __webpack_require__(68913);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/use-transform.mjs + 2 modules
var use_transform = __webpack_require__(80578);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/use-spring.mjs
var use_spring = __webpack_require__(4002);
// EXTERNAL MODULE: ./components/TinaImage/index.ts + 1 modules
var TinaImage = __webpack_require__(4605);
;// CONCATENATED MODULE: ./blocks/HorizontalSlideshow/HorizontalSlideshow.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  background: ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: ",
        ";\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  height: ",
        ";\n  ",
        "\n  // these equate to the 'lg' padding size in the cms\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    gap: 2rem;\n  "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  left: 0;\n  right: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  width: 100vw;\n  overflow: hidden;\n  ",
        "\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: inline-block;\n  padding: 0;\n  margin: 0;\n  @-moz-document url-prefix() {\n    width: max-content;\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 350px;\n    gap: 2rem;\n  "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  gap: 1rem;\n  height: 175px;\n  ",
        "\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  border-radius: 1rem;\n  // this fixes the images being streched on safari\n  object-fit: contain;\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100vw;\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}






const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e70550a2-0"
})(_templateObject(), ()=>(0,padding/* blockPadV */.zr)({
        pt: "no",
        pb: "no"
    }), (param)=>{
    let { theme  } = param;
    return theme.themeColors.bg;
});
const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e70550a2-1"
})(_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.themeColors.bg;
}, (param)=>{
    let { carousel2  } = param;
    return carousel2 ? "366px" : "175px";
}, (param)=>{
    let { theme , carousel2  } = param;
    return theme.mq.lg(_templateObject1(), carousel2 ? "732px" : "350px");
}, (param)=>{
    let { specialBottomPadding  } = param;
    return specialBottomPadding && "margin-bottom: 3.75rem;";
}, (param)=>{
    let { specialBottomPadding , theme  } = param;
    return theme.mq.md(_templateObject2(), specialBottomPadding && "margin-bottom: 5.675rem;");
});
const AnimationContainer = (0,styled_components_browser_esm/* default */.ZP)(motion/* motion.div */.E.div).withConfig({
    componentId: "sc-e70550a2-2"
})(_templateObject5(), (param)=>{
    let { theme  } = param;
    return theme.mq.lg(_templateObject4());
});
const CarouselWrapper = (0,styled_components_browser_esm/* default */.ZP)(motion/* motion.div */.E.div).withConfig({
    componentId: "sc-e70550a2-3"
})(_templateObject6());
const Carousel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e70550a2-4"
})(_templateObject8(), (param)=>{
    let { theme  } = param;
    return theme.mq.lg(_templateObject7());
});
const CarouselItem = (0,styled_components_browser_esm/* default */.ZP)(TinaImage/* default */.Z).withConfig({
    componentId: "sc-e70550a2-5"
})(_templateObject9());
const Ghost = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e70550a2-6"
})(_templateObject10());
const HorizontalSlideshow = (param)=>{
    let { carousel1 , carousel2 , specialBottomPadding  } = param;
    var ref;
    const topRef = (0,react.useRef)(null);
    const bottomRef = (0,react.useRef)(null);
    const ghostRef = (0,react.useRef)(null);
    const [scrollRange, setScrollRange] = (0,react.useState)(0);
    const [viewportW, setViewportW] = (0,react.useState)(0);
    const { scrollYProgress  } = (0,use_scroll/* useScroll */.v)();
    const physics = {
        damping: 15,
        mass: 0.27,
        stiffness: 55
    };
    const topTransform = (0,use_transform/* useTransform */.H)(scrollYProgress, [
        1,
        0
    ], [
        0,
        -scrollRange + viewportW
    ]);
    const topSpring = (0,use_spring/* useSpring */.q)(topTransform, physics);
    const bottomTransform = (0,use_transform/* useTransform */.H)(scrollYProgress, [
        0,
        1
    ], [
        0,
        -scrollRange + viewportW
    ]);
    const bottomSpring = (0,use_spring/* useSpring */.q)(bottomTransform, physics);
    const onResize = (0,react.useCallback)((entries)=>{
        for (const entry of entries){
            var ref;
            setViewportW(entry === null || entry === void 0 ? void 0 : (ref = entry.contentRect) === null || ref === void 0 ? void 0 : ref.width);
        }
    }, []);
    (0,react.useLayoutEffect)(()=>{
        const resizeObserver = new ResizeObserver((entries)=>onResize(entries));
        (ghostRef === null || ghostRef === void 0 ? void 0 : ghostRef.current) && resizeObserver.observe(ghostRef === null || ghostRef === void 0 ? void 0 : ghostRef.current);
        return ()=>resizeObserver.disconnect();
    }, [
        onResize
    ]);
    (0,react.useLayoutEffect)(()=>{
        var ref;
        (topRef === null || topRef === void 0 ? void 0 : (ref = topRef.current) === null || ref === void 0 ? void 0 : ref["scrollWidth"]) && setScrollRange(topRef === null || topRef === void 0 ? void 0 : topRef.current["scrollWidth"]);
    }, [
        topRef === null || topRef === void 0 ? void 0 : (ref = topRef.current) === null || ref === void 0 ? void 0 : ref["scrollWidth"]
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            carousel2: carousel2 ? true : false,
            specialBottomPadding: specialBottomPadding,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnimationContainer, {
                    initial: {
                        opacity: 0
                    },
                    animate: "show",
                    whileInView: {
                        opacity: 1
                    },
                    viewport: {
                        once: true
                    },
                    transition: {
                        type: "spring",
                        stiffness: 50,
                        opacity: {
                            duration: 1.4
                        }
                    },
                    children: [
                        carousel1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselWrapper, {
                            ref: topRef,
                            style: {
                                x: topSpring
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel, {
                                children: carousel1.map((carouselItem, idx)=>{
                                    return (carouselItem === null || carouselItem === void 0 ? void 0 : carouselItem.carousel1List) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselItem, {
                                        alt: "carousel item",
                                        src: carouselItem.carousel1List
                                    }, idx);
                                })
                            })
                        }),
                        carousel2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselWrapper, {
                            ref: bottomRef,
                            style: {
                                x: bottomSpring
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel, {
                                children: carousel2.map((carouselItem, idx)=>{
                                    return (carouselItem === null || carouselItem === void 0 ? void 0 : carouselItem.carousel2List) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselItem, {
                                        alt: "carousel item",
                                        src: carouselItem.carousel2List
                                    }, idx);
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Ghost, {
                    ref: ghostRef
                })
            ]
        })
    });
};
/* harmony default export */ var HorizontalSlideshow_HorizontalSlideshow = (HorizontalSlideshow);

;// CONCATENATED MODULE: ./blocks/HorizontalSlideshow/index.ts



/***/ }),

/***/ 3185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ GfxImage_GfxImage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/GfxImage/GfxImage.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}



const GfxImage = (param)=>{
    let { layout , quality , src , width =0 , height =0 , objectFit , blurDataURL , placeholder ="empty" , alt , ...rest } = param;
    if (!src) {
        return null;
    }
    const isLayoutFill = layout === "fill";
    const isSvg = src.includes(".svg");
    const imageProps = {
        layout,
        ...rest,
        ...isSvg && {
            unoptimized: true
        },
        ...placeholder === "blur" && {
            blurDataURL: blurDataURL
        },
        ...objectFit !== "none" && {
            style: {
                objectFit
            }
        },
        ...!isLayoutFill && {
            width: width,
            height: height
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        src: src,
        placeholder: placeholder,
        alt: alt,
        quality: quality,
        ...imageProps
    });
};
/* harmony default export */ var GfxImage_GfxImage = ((0,styled_components_browser_esm/* default */.ZP)(GfxImage).withConfig({
    componentId: "sc-2250b3a7-0"
})(_templateObject()));

;// CONCATENATED MODULE: ./components/GfxImage/index.ts



/***/ }),

/***/ 4605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TinaImage_TinaImage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./components/GfxImage/index.ts + 1 modules
var GfxImage = __webpack_require__(3185);
;// CONCATENATED MODULE: ./components/TinaImage/TinaImage.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  width: 100%;\n  padding: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}




const Container = (0,styled_components_browser_esm/* default */.ZP)(GfxImage/* default */.Z).withConfig({
    componentId: "sc-eb0d1e3b-0"
})(_templateObject1(), (param)=>{
    let { $horizontalPaddingMobile  } = param;
    return $horizontalPaddingMobile && "0 1.5rem";
}, (param)=>{
    let { theme  } = param;
    return theme.mq.md(_templateObject());
});
const TinaImage = (param)=>{
    let { src , layout =undefined , width =1024 , height =768 , ...props } = param;
    if (!src) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        layout: layout,
        width: width,
        height: height,
        ...props,
        src: src
    });
};
/* harmony default export */ var TinaImage_TinaImage = (TinaImage);

;// CONCATENATED MODULE: ./components/TinaImage/index.ts



/***/ }),

/***/ 4960:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ useMotionValue; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _index_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33234);
/* harmony import */ var _context_MotionConfigContext_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16014);
/* harmony import */ var _utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96681);





/**
 * Creates a `MotionValue` to track the state and velocity of a value.
 *
 * Usually, these are created automatically. For advanced use-cases, like use with `useTransform`, you can create `MotionValue`s externally and pass them into the animated component via the `style` prop.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const scale = useMotionValue(1)
 *
 *   return <motion.div style={{ scale }} />
 * }
 * ```
 *
 * @param initial - The initial state.
 *
 * @public
 */
function useMotionValue(initial) {
    const value = (0,_utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useConstant */ .h)(() => (0,_index_mjs__WEBPACK_IMPORTED_MODULE_2__/* .motionValue */ .B)(initial));
    /**
     * If this motion value is being used in static mode, like on
     * the Framer canvas, force components to rerender when the motion
     * value is updated.
     */
    const { isStatic } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_MotionConfigContext_mjs__WEBPACK_IMPORTED_MODULE_3__/* .MotionConfigContext */ ._);
    if (isStatic) {
        const [, setLatest] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initial);
        (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => value.onChange(setLatest), []);
    }
    return value;
}




/***/ }),

/***/ 75262:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useMultiOnChange; },
/* harmony export */   "p": function() { return /* binding */ useOnChange; }
/* harmony export */ });
/* harmony import */ var _utils_is_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40406);
/* harmony import */ var _utils_use_isomorphic_effect_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58868);



function useOnChange(value, callback) {
    (0,_utils_use_isomorphic_effect_mjs__WEBPACK_IMPORTED_MODULE_0__/* .useIsomorphicLayoutEffect */ .L)(() => {
        if ((0,_utils_is_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__/* .isMotionValue */ .i)(value))
            return value.onChange(callback);
    }, [callback]);
}
function useMultiOnChange(values, handler) {
    (0,_utils_use_isomorphic_effect_mjs__WEBPACK_IMPORTED_MODULE_0__/* .useIsomorphicLayoutEffect */ .L)(() => {
        const subscriptions = values.map((value) => value.onChange(handler));
        return () => subscriptions.forEach((unsubscribe) => unsubscribe());
    });
}




/***/ }),

/***/ 4002:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ useSpring; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var popmotion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90612);
/* harmony import */ var _utils_is_motion_value_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40406);
/* harmony import */ var _use_motion_value_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4960);
/* harmony import */ var _use_on_change_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75262);
/* harmony import */ var _context_MotionConfigContext_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16014);







/**
 * Creates a `MotionValue` that, when `set`, will use a spring animation to animate to its new state.
 *
 * It can either work as a stand-alone `MotionValue` by initialising it with a value, or as a subscriber
 * to another `MotionValue`.
 *
 * @remarks
 *
 * ```jsx
 * const x = useSpring(0, { stiffness: 300 })
 * const y = useSpring(x, { damping: 10 })
 * ```
 *
 * @param inputValue - `MotionValue` or number. If provided a `MotionValue`, when the input `MotionValue` changes, the created `MotionValue` will spring towards that value.
 * @param springConfig - Configuration options for the spring.
 * @returns `MotionValue`
 *
 * @public
 */
function useSpring(source, config = {}) {
    const { isStatic } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_MotionConfigContext_mjs__WEBPACK_IMPORTED_MODULE_1__/* .MotionConfigContext */ ._);
    const activeSpringAnimation = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const value = (0,_use_motion_value_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useMotionValue */ .c)((0,_utils_is_motion_value_mjs__WEBPACK_IMPORTED_MODULE_3__/* .isMotionValue */ .i)(source) ? source.get() : source);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
        return value.attach((v, set) => {
            /**
             * A more hollistic approach to this might be to use isStatic to fix VisualElement animations
             * at that level, but this will work for now
             */
            if (isStatic)
                return set(v);
            if (activeSpringAnimation.current) {
                activeSpringAnimation.current.stop();
            }
            activeSpringAnimation.current = (0,popmotion__WEBPACK_IMPORTED_MODULE_4__/* .animate */ .j)({
                from: value.get(),
                to: v,
                velocity: value.getVelocity(),
                ...config,
                onUpdate: set,
            });
            return value.get();
        });
    }, [JSON.stringify(config)]);
    (0,_use_on_change_mjs__WEBPACK_IMPORTED_MODULE_5__/* .useOnChange */ .p)(source, (v) => value.set(parseFloat(v)));
    return value;
}




/***/ }),

/***/ 80578:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ useTransform; }
});

// EXTERNAL MODULE: ./node_modules/popmotion/dist/es/utils/interpolate.mjs + 3 modules
var interpolate = __webpack_require__(59180);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/transform.mjs


const isCustomValueType = (v) => {
    return typeof v === "object" && v.mix;
};
const getMixer = (v) => (isCustomValueType(v) ? v.mix : undefined);
function transform(...args) {
    const useImmediate = !Array.isArray(args[0]);
    const argOffset = useImmediate ? 0 : -1;
    const inputValue = args[0 + argOffset];
    const inputRange = args[1 + argOffset];
    const outputRange = args[2 + argOffset];
    const options = args[3 + argOffset];
    const interpolator = (0,interpolate/* interpolate */.s)(inputRange, outputRange, {
        mixer: getMixer(outputRange[0]),
        ...options,
    });
    return useImmediate ? interpolator(inputValue) : interpolator;
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/use-motion-value.mjs
var use_motion_value = __webpack_require__(4960);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/use-on-change.mjs
var use_on_change = __webpack_require__(75262);
// EXTERNAL MODULE: ./node_modules/framesync/dist/es/index.mjs + 2 modules
var es = __webpack_require__(54735);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/value/use-combine-values.mjs




function useCombineMotionValues(values, combineValues) {
    /**
     * Initialise the returned motion value. This remains the same between renders.
     */
    const value = (0,use_motion_value/* useMotionValue */.c)(combineValues());
    /**
     * Create a function that will update the template motion value with the latest values.
     * This is pre-bound so whenever a motion value updates it can schedule its
     * execution in Framesync. If it's already been scheduled it won't be fired twice
     * in a single frame.
     */
    const updateValue = () => value.set(combineValues());
    /**
     * Synchronously update the motion value with the latest values during the render.
     * This ensures that within a React render, the styles applied to the DOM are up-to-date.
     */
    updateValue();
    /**
     * Subscribe to all motion values found within the template. Whenever any of them change,
     * schedule an update.
     */
    (0,use_on_change/* useMultiOnChange */.f)(values, () => es/* default.update */.ZP.update(updateValue, false, true));
    return value;
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(96681);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/value/use-transform.mjs




function useTransform(input, inputRangeOrTransformer, outputRange, options) {
    const transformer = typeof inputRangeOrTransformer === "function"
        ? inputRangeOrTransformer
        : transform(inputRangeOrTransformer, outputRange, options);
    return Array.isArray(input)
        ? useListTransform(input, transformer)
        : useListTransform([input], ([latest]) => transformer(latest));
}
function useListTransform(values, transformer) {
    const latest = (0,use_constant/* useConstant */.h)(() => []);
    return useCombineMotionValues(values, () => {
        latest.length = 0;
        const numValues = values.length;
        for (let i = 0; i < numValues; i++) {
            latest[i] = values[i].get();
        }
        return transformer(latest);
    });
}




/***/ })

}]);